// extracted by mini-css-extract-plugin
module.exports = {"action":"_2ZEueFJP"};